import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Axios from "axios";
import { useNavigate } from "react-router";
import {
  FaRegThumbsUp,
  FaThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
} from "react-icons/fa";
import { MdOutlineCategory, MdTimer } from "react-icons/md";
  import { GrShareOption } from "react-icons/gr";
import {
  filterPosts,
  getCategoriesByType,
  listPosts,
  profileUser,
} from "../api/service";
import { AiFillPlusCircle } from "react-icons/ai";
import toast, { Toaster } from "react-hot-toast";
import { RWebShare } from "react-web-share";
import Popover from "../components/Popover";
import useSearchParamsCustom from "../hooks/useSearchParamsCustom";
import { countItems } from "../utils/searchParams.utils";
import CategoryDropdown from "../components/Category";
import NewsCard from '../components/NewsCard'
import Filter from "../components/Filter";

function notifysuccess() {
  toast.success("Liked");
}

function notifyerror() {
  toast.error("Disiked");
}

const Posts = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };

  const [posts, setPosts] = useState([]);
  const [postTypes, setPostTypes] = useState();
  const [cities, setCities] = useState();
  const [states, setStates] = useState();
  const [countries, setCountries] = useState();

  const { setSearchParamsCustom, getSearchParam, deleteSearchParam } =
    useSearchParamsCustom();


    const fetchPosts = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/posts`, {
          headers: {
            authorization: token,
          },
        });
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
  
  const handleCategorySelect = (category, categoryName) => {
    const categories = getSearchParam(categoryName)?.split(",") || [];
    if (getSearchParam(categoryName)?.includes(category)) {
      if (countItems(getSearchParam(categoryName) || "") === 1) {
        deleteSearchParam(categoryName);
        return;
      }

      categories.splice(categories.indexOf(category), 1);
      setSearchParamsCustom(categoryName, categories.join(","));
    } else {
      categories.push(category);
      if (categories.length === 1) {
        setSearchParamsCustom(categoryName, category);
        return;
      }
      setSearchParamsCustom(categoryName, categories.join(","));
    }
  };

  const applyFilters = async () => {
    try {
      const postTypes = getSearchParam("postType") || [];
      const cities = getSearchParam("city") || [];
      const states = getSearchParam("state") || [];
      const countries = getSearchParam("country") || [];

      const filterParams = {
        postTypes,
        cities,
        states,
        countries,
      };

      const filteredProperties = await filterPosts(filterParams);
      console.log(filteredProperties);
      setPosts(filteredProperties);
      return filteredProperties;
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async (categoryType) => {
    try {
      const posts = await getCategoriesByType(categoryType);
      const categoriesSet = new Set();
      if (categoryType === "postType") {
        posts.forEach((post) => categoriesSet.add(post.category));
        setPostTypes(Array.from(categoriesSet));
      } else if (categoryType === "city") {
        posts.forEach((post) => categoriesSet.add(post.city));
        setCities(Array.from(categoriesSet));
      } else if (categoryType === "state") {
        posts.forEach((post) => categoriesSet.add(post.state));
        setStates(Array.from(categoriesSet));
      } else if (categoryType === "country") {
        posts.forEach((post) => categoriesSet.add(post.country));
        setCountries(Array.from(categoriesSet));
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  };

  const fetchUnfilteredPosts = async () => {
    listPosts(token)
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => console.log(err));
  };

  const removeFilters = () => {
    deleteSearchParam("postType");
    deleteSearchParam("city");
    deleteSearchParam("state");
    deleteSearchParam("country");
    fetchUnfilteredPosts();
  };

  useEffect(() => {
    profileInit();
    fetchCategories("postType");
    fetchCategories("city");
    fetchCategories("state");
    fetchCategories("country");
    fetchPosts();
  }, []);

  const [timeDifference, setTimeDifference] = useState({});

  useEffect(() => {
    const calculateTimeDifference = () => {
      const currentTime = new Date();
      const timeDifferences = {};

      posts.forEach((post) => {
        const postTime = new Date(post.createdAt);
        const timeDiff = currentTime - postTime;
        const minutes = Math.floor(timeDiff / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);

        if (weeks > 0) {
          timeDifferences[post._id] = `${weeks} week${
            weeks > 1 ? "s" : ""
          } ago`;
        } else if (days > 0) {
          timeDifferences[post._id] = `${days} day${days > 1 ? "s" : ""} ago`;
        } else if (hours > 0) {
          timeDifferences[post._id] = `${hours} hour${
            hours > 1 ? "s" : ""
          } ago`;
        } else if (minutes > 1) {
          timeDifferences[post._id] = `${minutes} minutes ago`;
        } else {
          timeDifferences[post._id] = "just now";
        }
      });
      setTimeDifference(timeDifferences);
    };
    calculateTimeDifference();
    const interval = setInterval(calculateTimeDifference, 60000);
    return () => clearInterval(interval);
  }, [posts]);

  const handleLike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/like`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, likes: response.data.likes };
        }
        return post;
      });

      setPosts(updatedPosts);
      notifysuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDislike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/dislike`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, dislikes: response.data.dislikes };
        }
        return post;
      });

      setPosts(updatedPosts);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Navbar />

      <div className="bg-[#FAF7F0]">
        <button
          className="fixed right-5 bottom-20 text-[#161b22]  dark:text-[#FAF7F0] bg-[#3E77E6] shadow-none dark:bg-[#1f7e30] font-bold py-2 px-4 dark:hover:bg-[#2ea043] rounded-xl h-10 my-4 "
          onClick={() => navigate("/addPost")}
        >
          <div style={{ display: "flex", justifyContent: "center" }}
            className="bg-[#3E77E6] shadow-none dark:bg-[#1f7e30]"
          >
            <AiFillPlusCircle className="w-6 h-6 sm:w-6 sm:h-6 " /> &nbsp;
            Create Post
          </div>
        </button>
        <button
          className="fixed right-5 bottom-20 text-[#161b22]  dark:text-[#FAF7F0] bg-[#3E77E6] shadow-none dark:bg-[#1f7e30] font-bold py-2 px-4 dark:hover:bg-[#2ea043] rounded-xl h-10 my-4 "
          onClick={() => navigate("/addPost")}
        >
          <div
            style={{ display: "flex", justifyContent: "center" }}
            className="bg-[#3E77E6] shadow-none dark:bg-[#1f7e30]"
          >
            <AiFillPlusCircle className="w-6 h-6 sm:w-6 sm:h-6 " /> &nbsp;
            Create Post
          </div>
        </button>
        <div className="heading px-4 py-2 bg-gray-300  ">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">Posts</h2>
        </div>
        <Filter postTypes={postTypes} cities={cities} states={states} countries={countries} handleCategorySelect={handleCategorySelect} applyFilters={applyFilters} removeFilters={removeFilters} countItems={countItems} getSearchParam={getSearchParam}/>
        <div className="this pt-2 dark:bg-[#010409] bg-[#FAF7F0]  flex flex-wrap justify-center">
          {/* some code was here */}
          <div className="post-grid grid justify-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:px-2 md:px-4 lg:px-16">
            {posts &&
              posts.length > 0 &&
              posts.map((post) => (
                <NewsCard
                  key={post._id}
                  post={post}
                  onLike={handleLike}
                  onDislike={handleDislike}
                  likesCount={post.likes.length}
                  dislikesCount={post.dislikes.length}
                  timeDifference={timeDifference}
                  postimg={`${post.image}`}
                />
              ))}
              
          </div>
        </div>
        <button
          className="fixed right-5 bottom-0  shadow-none text-[#d7dfe7] bg-[#1f7e30] font-bold py-2 px-4 hover:bg-[#2ea043] rounded-xl h-10 my-4"
          onClick={() => navigate("/addpost")}
        >
        </button>
        <Footer />
      </div>
    </>
  );
};

export default Posts;



// eslint-disable-next-line no-lone-blocks
{/* 
          <div className="flex flex-wrap justify-center col-span-2">
            {posts &&
              posts.length > 0 &&
              posts.map((post) => (
                <div
                  key={post._id}
                  className="self-center w-full md:w-1/3 pt-10 dark:bg-[#0D1117]  bg-[#c3d5ee] text-[#161b22]  dark:text-[#FAF7F0] border-2 dark:border-[#272e38] border-[#c2c3c5] rounded-lg shadow cursor-pointer mb-5 mx-2 hover:-translate-y-1 hover:scale-95 dark:hover:bg-[#141a24] hover:bg-[#b5c5dd] hover:z-0 duration-500"
                >
                  <div
                    style={{
                      alignItems: "center",
                    }}
                    className="self-center overflow-hidden rounded shadow-md"
                  >
                    <img
                      src={`${post.image}`}
                      alt=""
                      className="self-center inline object-cover w-full h-full rounded-t-lg md:w-48 md:h-48 md:rounded-none md:rounded-l-lg"
                      onClick={() => navigate(post._id)}
                    />
                    <div className="px-6 py-4">
                      <div className="flex flex-col justify-between leading-normal">
                        <h5 className=" text-xl font-bold tracking-tight uppercase text-[#161b22]  dark:text-slate-200 line-clamp-2">
                          {post.title}
                        </h5>
                        <br />
                        <div className="flex justify-content-center space-x-2 font-semibold text-xs text-[#c4d6fc] dark:text-[#759abd]">
                          <span className="inline-flex items-center justify-center rounded-lg bg-[#161b22] bg-opacity-40 backdrop-filter backdrop-blur-lg px-2.5 py-0.5">
                            <MdOutlineCategory size={15} className="mx-1" />
                            <p className="text-sm whitespace-nowrap">
                              {post.category}
                            </p>
                          </span>
                          <span className="inline-flex items-center justify-center rounded-lg bg-[#161b22] bg-opacity-40 backdrop-filter backdrop-blur-lg px-2.5 py-0.5">
                            <MdTimer size={15} className="mx-1" />
                            <p className="text-sm whitespace-nowrap">
                              {timeDifference[post._id] || "just now"}
                            </p>
                          </span>
                        </div>
                        <br />
                        <p className="mb-1 text-sm font-medium text-gray-600 dark:text-gray-400 text line-clamp-4">
                          {post.description}
                        </p>
                        <br />
                        <p className="font-medium text-gray-600 dark:text-gray-400">
                          {post.city}, {post.state}
                          <br />
                        </p>
                      </div>
                      <div className="flex justify-center w-full space-x-4">
                        <button
                          onClick={() => {
                            handleLike(post._id);
                            notifysuccess();
                          }}
                          className="flex items-center justify-center text-[#d7dfe7] bg-[#08161f] font-bold py-2 pl-4 hover:bg-[#0d212e] rounded-xl w-1/3 h-10 my-4 cursor-pointer transition-all px-6 border-green-400 border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px] active:border-b-[2px] active:brightness-90 active:translate-y-[2px] hover:shadow-lg hover:shadow-green-600 shadow-green-800 active:shadow-none"
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "30px",
                            }}
                          >
                            {post.likes.length}
                            <FaRegThumbsUp size={25} className="ml-1" />
                          </div>
                        </button>

                        <Toaster position="top-center" reverseOrder={true} />

                        <button
                          onClick={() => {
                            handleDislike(post._id);
                            notifyerror();
                          }}
                          className="flex items-center justify-center text-[#d7dfe7] bg-[#08161f] font-bold py-2 pl-4 hover:bg-[#0d212e] rounded-xl w-1/3 h-10 my-4 cursor-pointer transition-all px-6 border-red-400 border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px] active:border-b-[2px] active:brightness-90 active:translate-y-[2px] hover:shadow-lg hover:shadow-red-600 shadow-red-800 active:shadow-none"
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "30px",
                            }}
                          >
                            <span>{post.dislikes.length}</span>
                            <FaRegThumbsDown size={25} className="ml-1" />
                          </div>
                        </button>

                        <RWebShare
                          data={{
                            text: `🔴 ${post.title} \n\n ${post.description} \n\n Source: 💧 Jal Suraksha`,
                            url: `https://jal-suraksha.vercel.app/posts/${post._id}`,
                            title: `${post.title} (${post.city}) - Jal Suraksha`,
                          }}
                          onClick={() =>
                            console.log("News shared successfully!")
                          }
                        >
                          <button className="flex items-center justify-center text-[#d7dfe7] bg-[#08161f] font-bold py-2 pl-4 hover:bg-[#0d212e] rounded-xl w-1/3 h-10 my-4 cursor-pointer transition-all px-6 border-blue-400 border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px] active:border-b-[2px] active:brightness-90 active:translate-y-[2px] hover:shadow-lg hover:shadow-blue-600 shadow-blue-800 active:shadow-none">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <GrShareOption size={25} className="invert" />
                            </div>
                          </button>
                        </RWebShare>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div> */}